export interface HomepageFaqItem {
  question: string;
  answer: string;
}

export const HOMEPAGE_FAQ: HomepageFaqItem[] = [
  {
    question: "Welche Kreditkarte passt zu mir?",
    answer:
      "Das hängt vor allem von der Nutzung ab. Achten Sie auf Jahresgebühr, Kosten für Fremdwährung und Bargeld, enthaltene Versicherungen sowie darauf, ob Sie einen Kreditrahmen oder nur eine direkte Abbuchung benötigen.",
  },
  {
    question: "Was bedeutet effektiver Jahreszins bei einer Kreditkarte?",
    answer:
      "Der effektive Jahreszins zeigt die jährlichen Kreditkosten bei Teilzahlung. Er ist nur bei Kreditkarten mit Teilzahlungsfunktion relevant; bei Charge-, Debit- und Prepaidkarten gibt es keinen entsprechenden Kartenzins.",
  },
  {
    question: "Ist eine Kreditkarte ohne Jahresgebühr wirklich kostenlos?",
    answer:
      "Eine Jahresgebühr von 0 € bedeutet nur, dass keine regelmäßige Kartengebühr anfällt. Je nach Nutzung können trotzdem Kosten entstehen, etwa für Teilzahlung, Fremdwährung oder Bargeldabhebungen.",
  },
  {
    question: "Worauf sollte ich bei einer Reisekreditkarte achten?",
    answer:
      "Wichtig sind Gebühren für Zahlungen außerhalb der Eurozone und für Bargeldabhebungen. Bei Versicherungen sollten Sie zusätzlich prüfen, welche Reisen und Personen versichert sind und ob die Reise mit der Karte bezahlt werden muss.",
  },
  {
    question: "Was unterscheidet Kredit-, Charge-, Debit- und Prepaidkarten?",
    answer:
      "Eine Kreditkarte mit Teilzahlung bietet einen Kreditrahmen und kann Zinsen verursachen. Charge-Karten werden meist monatlich vollständig abgerechnet, Debitkarten belasten das Girokonto direkt und Prepaidkarten funktionieren nur mit vorher aufgeladenem Guthaben.",
  },
];

export const homepageFaqJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: HOMEPAGE_FAQ.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});